import { defineComponent } from 'vue'
import classNames from 'classnames'
import './HeaderComp.layout.scss'

export const HeaderCompLayout = defineComponent({
  name: 'HeaderCompLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('header-comp-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
